import * as React from 'react';


export default class ResolutionIcon extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fillRule="evenodd">
                    <path stroke="#43ADF1" strokeLinecap="round" strokeLinejoin="round" d="M8.617 11.636l3.409 3.409 8.882-7.706"/>
                    <path stroke="#878787" strokeDasharray="2" d="M11.412 3a9.412 9.412 0 1 0 0 18.824"/>
                    <path stroke="#878787" strokeLinecap="round" strokeLinejoin="round" d="M11.412 3c2.188 0 4.201.747 5.8 2m3.612 7.412a9.412 9.412 0 0 1-9.412 9.412"/>
                </g>
            </svg>
        )
    }
}